import { FC, useCallback } from "react";
import { t } from "i18next";

import {
  PaymentMethodSelectorProps,
  PaymentOptionTypes,
} from "@models/services/pricing";

export const PaymentMethodSelector: FC<PaymentMethodSelectorProps> = ({
  disablePaymentOption,
  onSelectPaymentMethod,
  paymentOptions,
  selectedPaymentMethod,
}) => {
  const renderPaymentOption = useCallback(
    (obj: PaymentOptionTypes, paymentType?: string) => {
      const isSelected = selectedPaymentMethod === obj.type;
      const buttonLabel = paymentType ? t(paymentType) : t(obj.type);

      return (
        <button
          className={`btn fg-btn fg-payment-btn ${disablePaymentOption ? "disabled" : ""} ${isSelected ? "active" : ""}`}
          key={`${paymentType || ""}-${obj.type}`}
          disabled={disablePaymentOption}
          aria-pressed={isSelected}
          aria-label={`Select ${buttonLabel} payment method`}
          onClick={() => {
            if (!disablePaymentOption) {
              onSelectPaymentMethod(obj.type);
            }
          }}
        >
          <h6 className="mb-0">{buttonLabel}</h6>
          {paymentType && <span>{t(obj?.type)}</span>}
        </button>
      );
    },
    [selectedPaymentMethod, disablePaymentOption, onSelectPaymentMethod]
  );

  if (!paymentOptions?.length) return null;

  return (
    <div className="fg-tab-unit-list">
      <div data-testid="pricing-test">
        <div className="fg-guest-count-form">
          <h5>{t("paymentMethod")}</h5>
          {!selectedPaymentMethod && !disablePaymentOption && (
            <p className="fg-payment-method-label">
              {t("selectPaymentToProceed")}
            </p>
          )}

          <div className="fg-payment-btn-wrap">
            {paymentOptions.map(obj => {
              if (!obj?.availableMethods) {
                return renderPaymentOption(obj);
              }
              return obj.availableMethods.map(item => {
                return renderPaymentOption(item, obj.type);
              });
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
